export default {
  // 获取仓库列表
  GET_STORE_LIST_API: '/maindata/storage/listPageV2',
  // 修改仓库状态
  UPDATE_STORE_STATUS: '/maindata/storage/updateStatus',
  // 判断仓库名是否已经存在
  CHECK_STORE_NAME: '/maindata/storage/checkStorageNameDuplicate',
  // 创建或提交仓库信息
  CREATE_OR_SAVE_STORE_INFO: '/maindata/storage/saveStorageV2',
  // 导出excel
  EXPORT_EXCEL_FILE: '/maindata/storage/exportStorageExcelV2',
  // 获取下一级仓库数据
  GET_SUB_STORAGE: '/maindata/storage/getSubStoragesByPage',
  // 根据id获取表单数据反填
  GET_FORM_DATA_BY_ID: '/maindata/storage/getDetailById',
  // 修改仓库数据
  UPDATE_STORE_DATA: '/maindata/storage/updateStorageV2',
  // 获取仓库级别下拉框
  GET_STORAGE_DROP_DOWN: '/maindata/storage/dropDown',
};
